import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { change } from 'redux-form';

import { getRadioOptions } from 'src/reducers/selectOptions';
import { RadioField } from 'src/jbc-front/components/Form';
import { getAllowanceFormValues } from 'src/reducers/clients/allowances';
import selector from 'src/utils/Utils';

import { CLIENT_ALLOWANCE_FORM } from 'src/constants/FormNames';

import AllowanceDeductionFixed from './AllowanceDeductionFixed';
import AllowanceDeductionFormula from './AllowanceDeductionFormula';
import AllowanceDeductionIndividual from './AllowanceDeductionIndividual';

const AllowanceDeduction = ({
  selectedAllowanceAmountType,
  isYearEndAdjustment,
  isBaseSalaryOrComputing,
  formulaOrderType,
  allowanceAmountTypes,
  payrollRulesGroup,
  dispatch
}) => {

  const { t } = useTranslation();

  useEffect(() => {
    dispatch(change(CLIENT_ALLOWANCE_FORM, 'paymentType', 'normal'));
  }, []);

  return (
    <>
      {!isYearEndAdjustment && (
        <RadioField
          label={t('features.ClientAllowances.components.AllowanceEditingForm.Amount_Setting')}
          name="allowanceAmountType"
          required
          options={allowanceAmountTypes.slice(1)}
          disable={isBaseSalaryOrComputing || formulaOrderType === 'provident_fund'}
        />
      )}

      <div>
        {selectedAllowanceAmountType === 'fixed' && <AllowanceDeductionFixed payrollRuleGroup={payrollRulesGroup} />}
        {selectedAllowanceAmountType === 'formula' && <AllowanceDeductionFormula />}
        {selectedAllowanceAmountType === 'individual' && <AllowanceDeductionIndividual />}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  selectedAllowanceAmountType: selector(getAllowanceFormValues(state), 'allowanceAmountType'),
  formulaOrderType: selector(getAllowanceFormValues(state), 'formulaOrderType'),
  allowanceAmountTypes: getRadioOptions(state, 'allowanceAmountTypes'),
  selectedAllowancePaymentType: selector(getAllowanceFormValues(state), 'allowancePaymentType'),
});

export default connect(mapStateToProps)(AllowanceDeduction);
